<nb-tabset>
    <nb-tab tabTitle="Consulta Usuarios - Operadores" tabIcon="people-outline" responsive>
        <div style="margin-bottom: 8px;">
            <nb-select size="tiny" placeholder="Empresa" [(ngModel)]="empresaSelected">
                <nb-option *ngFor="let empresa of empresas" value="{{empresa.value}}">{{empresa.label}}</nb-option>
            </nb-select>

            <nb-select size="tiny" placeholder="Perfil" [(ngModel)]="perfilSelected">
                <nb-option *ngFor="let perfil of perfiles" value="{{perfil.value}}">{{perfil.label}}</nb-option>
            </nb-select>
            <!-- <nb-radio-group [(ngModel)]="flagActivo" >
                <nb-radio class="radioButton"
                    *ngFor="let option of optAct"
                    [value]="option.value">
                    {{ option.label }}
                </nb-radio>
            </nb-radio-group> -->
            <button nbButton size="tiny" style="float: right;" class="buttontz" (click)="consultarUsuarios()">Buscar</button>
        </div>
        <app-spinner *ngIf="showSpinner"></app-spinner>
        <div *ngIf="showGrilla">
        <div *ngIf="!showSpinner">
            <!-- <angular-slickgrid 
                gridId="gridUsuario"
                [columnDefinitions]="columnDefinitionsUsuarios"
                [gridOptions]="gridOptionsUsuarios" 
                [dataset]="datasetUsuarios" 
                gridHeight="380"
                gridWidth="100%"
                (onAngularGridCreated)="angularGridReady($event)">
            </angular-slickgrid> -->
            
        <ag-grid-angular
            #grilla1
            class="ag-theme-alpine"
            style="width: 100%; height: 380px;"
            [rowData]="datasetUsuarios"
            [columnDefs]="columnDefinitionsUsuarios"
            (gridReady)="onGridReady($event)" 
            [enableCellTextSelection]="true"/>
        </div>
        </div>
        <button nbButton size="tiny" style="float: right; margin-top: 5px; margin-bottom: 1%;"  class="buttontz" [disabled]="deshabilitarExportUser"
        (click)="exportToExcelUsuarios()"><nb-icon icon="save-outline"></nb-icon>Exportar</button>
    </nb-tab>
</nb-tabset>








